module.exports = __webpack_public_path__ + "static/startups-3cc810a715b572bb5eadfb4f81489b37.png";